<script setup lang="ts">
import DriverGauges from './DriverGauges.vue';
import EmptyStateIconUrl from '@Shared/components/visuals/visualAssets/EmptyState_Icon.svg?url';

defineProps<{
  hasNoData: boolean | undefined;
  isFrontline: boolean;
}>();
</script>

<template>
  <div class="flex flex-col xs:hidden xl:block shrink-0 w-[140px] bg-[#F4F6Fb] sticky top-[0]"></div>
  <div class="relative flex flex-col w-full md:pr-6 bg-[#FFFFFF] items-center">
    <div class="flex flex-row mt-2 w-[85%] justify-center">
      <DriverGauges :hasNoData="hasNoData" :isFrontline="isFrontline" :inPopup="true" />
    </div>
    <hr class="xs:hidden xl:block h-[2px] w-[85%] b-0 mt-5 mb-5 text-[#E0E0E0] bg-[#E0E0E0]" />
    <div class="xs:hidden xl:flex flex-row mt-2 h-[150px] w-[85%] justify-center">
      <DriverGauges :hasNoData="hasNoData" :isFrontline="isFrontline" :inPopup="true" />
    </div>
    <div class="xs:hidden xl: flex flex-row mt-5 h-[150px] w-[85%] justify-center">
      <DriverGauges :hasNoData="hasNoData" :isFrontline="isFrontline" :inPopup="true" />
    </div>
    <div
      v-if="hasNoData"
      class="xs:top-20% xs:text-4 xs:line-height-1.5rem absolute xl:top-35% text-center w-full text-[#828282] xl:text-sm xl:text-3 font-family[Roboto] xl:line-height-1rem"
    >
      <img :src="EmptyStateIconUrl" alt="" />
      <div class="xs:max-w-[250px] xl:max-w-[300px] m-auto">
        <span>
          Nothing to see here. <br />
          You can try changing the <strong>filter</strong>.
        </span>
      </div>
    </div>
  </div>
</template>
